import React from 'react';
import { DataProtection } from '../components';

export default () => {
    return (
        <DataProtection.Home />
    )
}